<script>
    import CompanyAPI from 'api/CompanyAPI'
    import RoutesEnum from 'enums/routes.enum'
    export default {
        mounted() {
            if (this.$route.params.id) {
                CompanyAPI.getCompanyByQrcodeId(this.$route.params.id)
                    .then((response) => {
                        window.location.href = `https://${response.subdomain}.${window.location.host}`
                    })
                    .catch(() => {
                        this.$router.push({ name: RoutesEnum.INDEX.HOME })
                    })
            }
        },
    }
</script>
